import type { FeatherIconNames } from "feather-icons";
import type { ComponentProps } from "react";

import { CircleButton } from "./CircleButton";
import { Icon } from "./Icon";

export function IconButton({
  name, // TODO: rename this prop to "icon"
  size = 24,
  ...props
}: { name: FeatherIconNames } & Omit<ComponentProps<typeof CircleButton>, "name">) {
  return (
    <CircleButton size={size} {...props}>
      <Icon name={name} size={size} />
    </CircleButton>
  );
}
